var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/home/viewmodels/home',["require", "exports", "durandal/app", "models/account", "common/viewmodelbase"], function (require, exports, App, Account, ViewModel) {
    "use strict";
    var HomeViewModel = (function (_super) {
        __extends(HomeViewModel, _super);
        //#region ctor
        function HomeViewModel() {
            _super.call(this);
            //#endregion
            this.isAuthenticated = Account.Session.isAuthenticated;
            this.title = $.t("app:modules.home.headline_title", { ifMissing: "home" });
            ko.track(this, ["isAuthenticated"]);
            if (!Account.Session.isAuthenticated) {
                App.on('authentication', this.onAuthenticationChanged, this);
            }
        }
        HomeViewModel.prototype.onActivated = function (context) {
            this.isAuthenticated = Account.Session.isAuthenticated;
            return Q(true);
        };
        HomeViewModel.prototype.onAuthenticationChanged = function (value) {
            this.isAuthenticated = Account.Session.isAuthenticated;
        };
        return HomeViewModel;
    }(ViewModel.ViewModelBase));
    var instance = new HomeViewModel();
    return instance;
});

